/**
 * Alpine.js wrapper component for managing quick addition of products from outside the product detail page (PDP).
 * Features include:
 * - Handling quick addition of products to the cart.
 * - Opening the quick add drawer to select product variants.
 * - Displaying alerts for errors during product addition to the cart.
 * - Updating the cart and opening it after adding products.
 * - Managing the quick add drawer state and title.
 * - Handling events to open and update the quick add drawer.
 * - klaviyoCompanyId - The Klaviyo company ID for tracking.
 * - klaviyoComingSoonListId - The Klaviyo list ID for products coming soon.
 */

const quickAddDrawerWrapper = (klaviyoCompanyId, klaviyoComingSoonListId) => ({
  klaviyoCompanyId,
  quickAddDrawerProduct: null,
  quickAddDrawerSelectedOptions: null,
  quickAddDrawer: false,
  drawerTitle: '',
  drawerSide: '',
  klaviyoComingSoonListId,
  isWorking: false,

  async quickAddToCart(varId) {
    if (this.isWorking) return;

    const simpleId = varId.replace('gid://shopify/ProductVariant/', '');

    try {
      this.isWorking = true;

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: simpleId, quantity: 1 }],
        }),
      });

      if (!response.ok) {
        let description = '';
        try {
          const data = await response.json();
          description = data?.description || '';
        } catch (error) {}
        throw new Error(`Failed to add to cart! ${description} (status: ${response.status})`);
      }
      this.$dispatch('update-and-open-cart', {
        noOpenAfterUpdate: window.CURRENT_TEMPLATE === 'cart',
      });
      this.isWorking = false;
    } catch (error) {
      alert(error.message);
      this.isWorking = false;
    }
  },

  async open({ product, selectedOptions, selectSecondVariant }) {
    // always create new component instance
    if (product.variants.length === 1 && product.variants[0].availableForSale) {
      try {
        await this.quickAddToCart(product.variants[0].id);
      } catch (e) {
        console.error('error adding to cart', e);
      }
      return;
    }
    const matcher = window.matchMedia(`(min-width: 1024px)`);
    this.quickAddDrawer = false;
    await this.$nextTick();
    this.drawerTitle = '';
    this.drawerSide = matcher.matches ? 'right' : 'bottom';
    this.selectSecondVariant = selectSecondVariant;
    this.quickAddDrawerProduct = product;
    this.quickAddDrawerSelectedOptions = selectedOptions || null;
    this.quickAddDrawer = true;
    this.$el.querySelector('dialog').showModal();
  },

  handleOpenAddDrawer(event) {
    this.open(event.detail);
  },

  async handleUpdateAddDrawerTitle(event) {
    await this.$nextTick(); // some weird race condition
    this.drawerTitle = event.detail;
  },
});

document.addEventListener('alpine:init', () => {
  Alpine.data('quickAddDrawerWrapper', quickAddDrawerWrapper);
});
